import React from 'react'
import ThreeDotsIcon from '../Assets/Icons/threeDots.svg'
import AvatarGroup from './AvatarGroup';
import TeamImg from '../Assets/TeamProfile.png'

export default function AITeamCard (props) {
    return(
        <div>
           <div className='w-[18rem] py-4 px-4 border-[1px] bg-white rounded-[12px] border-[#E5E7EB]'>
            <div className='flex items-end justify-end'>
                <img src={ThreeDotsIcon} />
            </div>
            <div>
             <img className='w-[3.5rem] h-[3.5rem] rounded-[8px]' src={TeamImg} />
            </div>
            <div className='flex flex-col gap-[2px] mt-[8px]'>
                <h2 className='text-[1.1rem] font-[500] text-[#111928]'>{props.teamname}</h2>
                <p className='text-[0.90rem] text-[#6B7280]'>{props.text}</p>
            </div>
            <div className='flex flex-col gap-1 mt-3'>
                <p className='text-[0.90rem] text-[#6B7280]'>Team members</p>
                <AvatarGroup />
            </div>
            <p className='text-[0.90rem] text-[#6B7280] font-[500] mt-2'>Assigned AI Project <span className='text-[#942A27]'>{props.projectname}</span></p>
           </div>
        </div>
    );
}